var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Detail"},[_c('Empty',{attrs:{"description":"努力开发中，敬请期待..."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }